/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './getConvoAvailability.defs'
export { main as default } from './getConvoAvailability.defs'
